import React, {PureComponent} from 'react';
import { Col, Container, Row, Input } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import {bindActionCreators} from "redux";
import { filter, compact } from 'lodash';

import { Icons } from './components/Icons';
import ComponentFilter from './ComponentFilter'
import {loadComponentsByPage} from "../../../redux/actions/componentActions";
import {openComponent} from "../../../redux/actions/componentActions";
import appConfig from "../../../config/constants";


class InfiniteScrollExtend extends InfiniteScroll{
  componentDidUpdate(prevProps, prevState){
    if(prevProps.pageStart !== this.props.pageStart){
      this.pageLoaded = 1;
    }
    this.attachScrollListener();
  }
}

class AssetsHealth extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            hasMoreItems: true,
            sortBy: false,
            pageStart: 0
        };

        this.options = {
            onRowClick: (row) => this.rowClickHandler(row)
        };
    }

    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
    };

    componentDidMount() {
        const includePendingCcount=1;
        this.props.loadComponentsByPage({includePendingCcount});
    }

    rowClickHandler = row => {
        this.props.openComponent(row);
        this.props.history.push('/asset_health_report');
    };

    moreLoader = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> Loading more events
        </div>
    );

   PendingReviewSummery = () =>(
        <div className="title-details normal-t-b-space">
            <div className="col-lg-6 col-sm-6 col-xs-12">
                <h5>Number of Asset Components Pending Review: <span>{this.props.pendingComponentCount}</span></h5>
            </div>
            <div className="col-lg-6 text-right col-sm-6 col-xs-12">
                <h6>
                    <span><i className="fa fa-circle active" aria-hidden="true" />Pending Review</span>
                    <span><i className="fa fa-circle " aria-hidden="true" />Reviewed </span>
                </h6>
            </div>
        </div>
    );

    sortByChangeHandler = e => {
        const { loadComponentsByPage, assetsHealthFilterFieldData } = this.props;
        const sortBy = e.target.value;

        this.setState(
          { sortBy },
          () => loadComponentsByPage({
              filterFieldData: assetsHealthFilterFieldData,
              sortBy,
          })
        );
    };

    alterString = function(str) {
      return str && str.length > 0  && str.replace(/_/g,' ').toLowerCase()
        .replace(/^.|\s\S/g, function(a) {
          return a.toUpperCase();
        })
    };

    eventSortingBar = () => {
        const { assetsHealthFilterFieldData } = this.props;
        let filterLabelArray = assetsHealthFilterFieldData ? assetsHealthFilterFieldData.split('&') : [];
        filterLabelArray = compact(filterLabelArray);
        const labelData = {
          "action_status" : "Action Status",
          "ai_confidence" : "AI Confidence",
          "collection_name" : "Collection",
          "asset_name" : "Asset",
          "asset_type" : "Asset Type",
          "event_type" : "Event Type",
          "health_status" : "Health Status",
          "component_name" : "Component Name",
          "aggregate_severity" : "Severity"
        };

        let selectedSource = [];
        filter(filterLabelArray, (filterLabel) => {
          const key = filterLabel.substring(0, filterLabel.indexOf('='));
          const value = filterLabel.substring(filterLabel.indexOf('=') + 1);

          selectedSource.push({
            name: `${labelData[key]}: ${this.alterString(value)}`
          });
        });

        return(
            <div className="title-details">
            <div className="col-lg-6 col-sm-6 col-xs-12">
                {selectedSource.map((item)=>
                    <a href="#" className="btn-primary">{item.name} <img src="img/close.png" alt=""/></a>
                )}
            </div>
            <div className="col-lg-6 text-right col-sm-6 col-xs-12">
                <ul>
                    <li className="sort"><b>Sort By</b></li>
                    <li>
                        <Input
                          type="select" bsSize="sm"
                          className={"sort-by-dropdown"}
                          onChange={this.sortByChangeHandler}
                        >
                            <option value=''>Select</option>
                            {appConfig.APP == "ANOMALY"? "":
                                <option value={'rul'}>RUL</option>
                            }
                            <option value={'health_score'}>Health Score</option>
                            <option value={'updatedDate'}>Update Time</option>
                            <option value={'asset_name'}>Asset Name</option>
                            <option value={'component_name'}>Component Name</option>
                        </Input>
                    </li>
                </ul>
            </div>
        </div>
      )
    };

    callLoadMore = (page) => {
        console.log("Load More called with page:", page);
        const { totalPage, assetsHealthFilterFieldData } = this.props;
        const { sortBy  } = this.state;
        if(totalPage >= page) {
            if (sortBy) {
                this.props.loadComponentsByPage({page, filterFieldData: assetsHealthFilterFieldData, sortBy});
            } else {
                this.props.loadComponentsByPage({page, filterFieldData: assetsHealthFilterFieldData});
            }
        } else {
            this.setState({
                hasMoreItems:false,
            })
        }
    };

    loadingComponentData = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> Loading Asset Components
        </div>
    );

    noComponentData = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> No component found!
        </div>
    );

    componentWillReceiveProps(nextProps){
        const { currentPage, totalPage } = nextProps;
        console.log("received current page:", currentPage);
        console.log("received total page:", totalPage);
        if (currentPage ==1 && totalPage >0){
            const { pageStart } = this.state;
            this.setState({  pageStart: pageStart === 1 ? 0 : 1 });
            console.log("setting hasMoreItems to true");
            this.setState({
                 hasMoreItems:true,
            })
        }
    }

    notShowRulColumn = () =>{
        if (appConfig.APP =="ANOMALY") {
            return true;
        } else {
            return false;
        }
    }

    render() {
        const { componentPages, t, loadingComponent, totalPage } = this.props;
        const { hasMoreItems, sortBy, pageStart  } = this.state;
        console.log("hasMoreItems: ",hasMoreItems)

        function severityLabel (val) {
            let color = '';
            switch (val) {
                case 'CRITICAL' :
                    color = '';
                    break;
                case 'MAJOR' :
                    color = 'orange';
                    break;
                case 'MINOR' :
                    color = 'yellow';
                    break;
                case 'NORMAL' :
                    color = 'green';
                    break;
                default:
                    color = '';
            }
            return color;
        }
        function valueFeverity(cell) {
            return <mark className={severityLabel(cell)}>{cell}</mark>;
        }

        function componentFormate(cell,row) {
            return <React.Fragment><b>{cell}</b><br/>{row.component_type_name}</React.Fragment>;
        }

        function oldAssetsFormate(cell,row) {
            return <React.Fragment><b>{cell}</b><br/>{row.parent_source_type_name}</React.Fragment>;
        }

        function valueAiConfidence(cell) {
            return <React.Fragment><div className={cell==='LOW'?'red-circle':(cell==='MEDIUM'?'yellow-circle':'green-circle')} />{cell}</React.Fragment>
        }

        const assetsFormate = (cell,row) => {
            return (
              <React.Fragment>
                    <span>
                        <Icons health_score={row.health_score} />
                    </span>
                    <b>{cell}</b><br/>{row.asset_type_name}
              </React.Fragment>
            )
        };


      function columnClassNameFormat(fieldValue, row) {
        return row.review_status === 'PENDING' ? 'event-status-pending' : 'td-column-function-odd-example';
      }



    return(<Container id="content">
        <Row>
            <Col md={12}>
                <h3 className="page-title"> {appConfig.APP=="ANOMALY"? t('asset_health.anomaly_app_title'):t('asset_health.title')}</h3>
            </Col>
        </Row>

        <Row>
            <ComponentFilter sortBy={sortBy} />
            <div className="row field number full-width">
                <div className="col-lg-12 col-xs-12 col-sm-12">
                    <div className="white-bg">
                        {this.PendingReviewSummery()}
                        {this.eventSortingBar()}
                        <div className="pro space-top-0 events">
                            <div className="table-responsive">
                               {loadingComponent ? (this.loadingComponentData()) :
                               (totalPage >0 &&
                                <InfiniteScrollExtend
                                    pageStart={pageStart}
                                    loadMore={this.callLoadMore}
                                    hasMore={hasMoreItems}
                                    initialLoad={false}
                                    loader={this.moreLoader()}
                                >
                                    <BootstrapTable
                                      data={componentPages}
                                      options={this.options}
                                      striped
                                      hover
                                      condensed
                                      responsive
                                      trClassName="trClassFormat"
                                      tableBodyClass="spacingBorder"
                                      tableContainerClass="tableContainer table-responsive"
                                      tableHeaderClass="tableHeader"
                                      bordered={false}
                                    >
                                        <TableHeaderColumn
                                          dataSort
                                          dataField="asset_name"
                                          dataFormat={assetsFormate}
                                          width="25%"
                                          columnClassName={ columnClassNameFormat }
                                        >
                                            {t('asset_health.asset_labels.asset_name')} /
                                            {t('asset_health.asset_labels.type')}
                                        </TableHeaderColumn>

                                        <TableHeaderColumn
                                          dataSort
                                          dataField="component_name"
                                          dataFormat={componentFormate}
                                          width="15%"
                                        >
                                            {t('asset_health.asset_labels.component_name')} /
                                            {t('asset_health.asset_labels.type')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                          dataSort
                                          dataField="aggregate_status"
                                          width="15%"
                                        >
                                            {t('asset_health.asset_labels.health_status')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                          dataSort
                                          dataField="rul"
                                          width="15%"
                                          hidden={this.notShowRulColumn()}
                                         >
                                            {t('asset_health.asset_labels.rul')}
                                            ({t('asset_health.asset_labels.days')})
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                          dataSort
                                          dataFormat={valueAiConfidence}
                                          dataField="last_ai_confidence"
                                          width="10%"
                                        >
                                            ({t('asset_health.asset_labels.ai_confidence')})
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                          dataSort
                                          dataFormat={valueFeverity}
                                          dataField="aggregate_severity"
                                          width="10%"
                                        >
                                            ({t('asset_health.asset_labels.severity')})
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                          dataSort
                                          dataField="review_status"
                                          width="10%"
                                        >
                                            ({t('asset_health.asset_labels.action')})
                                        </TableHeaderColumn>
                                        <TableHeaderColumn isKey dataField="_id"  hidden={true}></TableHeaderColumn>
                                    </BootstrapTable>
                                </InfiniteScrollExtend>
                                )}
                                {totalPage ==0 ? this.noComponentData():''}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
    </Container>)
    }
}

AssetsHealth.propTypes = {
    t: PropTypes.func.isRequired,
    openComponent: PropTypes.func.isRequired,
};

function mapStateToProps({component}) {
    return {
        componentPages: component.componentPages,
        currentPage: component.currentPage,
        totalPage: component.totalPage,
        pendingComponentCount: component.pendingComponentCount,
        assetsHealthFilterFieldData: component.assetsHealthFilterFieldData,
        loadingComponent:component.loadingComponent,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadComponentsByPage,
            openComponent 
        },
        dispatch
    );
}

export default withTranslation('common') (
    connect(
    mapStateToProps,
    mapDispatchToProps
    )(AssetsHealth)
);
